import { Observable, BehaviorSubject } from 'rxjs';

import { Logger } from '@bo-client/core/logger.service';

const log = new Logger('AuthInterceptor');
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpSentEvent,
  HttpHeaderResponse,
  HttpProgressEvent,
  HttpResponse,
  HttpUserEvent
} from '@angular/common/http';
import { AuthenticationService } from '@bo-client/core/authentication/authentication.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { path } from '@bo-client/shared/constants/path';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { TenantDto } from '@bo-client/shared/models/tenantDto';
import { HttpHapService } from '@bo-client/core/http/http-hap.service';

@Injectable()
export class TenantHeaderInterceptor implements HttpInterceptor {
  isRefreshingToken = false;
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor(
    private authService: AuthenticationService,
    private httpHapService: HttpHapService,
    private dataShareService: DataShareService,
    private router: Router,
    private toastR: ToastrService
  ) {}

  addTenantHeader(req: HttpRequest<any>): HttpRequest<any> {
    // Explizit gesetzten X-Tenant beibehalten (z. B. Template-Beispieldaten-Dialog im Mandanten „tsg“:
    // Nutzer wählt anderen Mandanten für Outbox/Vorschaudaten). Alle Services, die X-Tenant setzen,
    // tun das bewusst für diesen Mandanten; Überschreiben würde das kaputt machen.
    if (req.headers.has('X-Tenant')) {
      return req;
    }

    let selectedTenant = new TenantDto();
    if (this.dataShareService.selectedTenant) {
      selectedTenant = this.dataShareService.selectedTenant;
    }
    return req.clone({ setHeaders: { ['X-Tenant']: selectedTenant.id } });
  }

  handleMissingTenant() {
    this.router.navigateByUrl(path.hapPrefix + '/' + path.hapTenant + '/' + path.hapTenantList);
    this.toastR.warning('Bitte wählen Sie zuerst einen Mandanten aus.');
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<
    HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>
  > {
    return next.handle(this.addTenantHeader(req)) as any;
  }
}
